//
import { RForm } from '@/components/reusable_components/next'

//
export default {
    beforeMount() {
        this.init()
    },
    components: {
        RForm,
    },
    computed: {

        /**
         * @description
         * { function_description }
         *
         * @return     {string}  { description_of_the_return_value }
         */
        title() {
            return 'titulo'
        },
    },
    methods: {

        /**
         * @description
         * Initializes the object.
         */
        init() {
            this.setTitle(this.title)
        },

        /**
         * @description
         * Reset the object.
         */
        reset() {

        },

        /**
         * @description
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },
    },
    mounted() {
        this.reset()
    },
}
